import { render, staticRenderFns } from "./YioksPrivacyText.vue?vue&type=template&id=083a58ee&scoped=true&"
import script from "./YioksPrivacyText.vue?vue&type=script&lang=js&"
export * from "./YioksPrivacyText.vue?vue&type=script&lang=js&"
import style0 from "./YioksPrivacyText.vue?vue&type=style&index=0&id=083a58ee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083a58ee",
  null
  
)

export default component.exports